<button type="button" class="btn d-none" data-toggle="modal" [attr.data-target]="'#repo-modal_' + (key || '')" id="btn-repo-modal_{{key || ''}}"></button>
<div id="repo-modal_{{key || ''}}" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h2>Repossession Panel</h2>
                @if (receivable) {
                    <p class="subtitle">{{receivable.contact}} | {{receivable.vehicle}} | {{receivable.stock}}</p>
                }
            </div>
            <div class="modal-body">
                <ul id="repo-modal-tabs" class="nav nav-tabs">
                    @if (canRepo) {
                        <li class="nav-item">
                            <a href="#" id="repo-setup-link" data-toggle="tab" data-target="#repo-setup" class="nav-link">Repossession</a>
                        </li>
                    }
                    <li class="nav-item">
                        <a href="#" id="repo-letters-link" data-toggle="tab" data-target="#repo-letters" class="nav-link">Letters</a>
                    </li>
                </ul>
                <div id="repo-modal-tab-panes" class="tab-content">
                    @if (canRepo) {
                        <div class="tab-pane" id="repo-setup">
                            <form [formGroup]="form">
                                <div class="form-row form-group">
                                    <div class="col-form-label col col-xs-12">
                                        <label for="last" class="text-muted">Last Payment</label>
                                    </div>
                                    <div class="col">
                                        <input type="text" readonly class="form-control-plaintext text-muted" id="last" formControlName="lastPayment" />
                                    </div>
                                    <div class="col-form-label col col-xs-12">
                                        <label for="when">Repossessed</label>
                                    </div>
                                    <div class="col">
                                        <input type="date" class="form-control form-control-sm" id="when" formControlName="when" />
                                    </div>
                                </div>
                                <div class="form-row form-group">
                                    <div class="col-form-label col col-xs-12">
                                        <label for="daysAvailable">Days Before Available</label>
                                    </div>
                                    <div class="col">
                                        <count-input id="daysAvailable" [control]="form.get('daysAvailable')"></count-input>
                                    </div>
                                    <div class="col-form-label col col-xs-12">
                                        <label for="available">Available</label>
                                    </div>
                                    <div class="col">
                                        <input type="date" class="form-control form-control-sm" id="available" formControlName="available" />
                                    </div>
                                </div>
                                <hr />
                                <h4><span class="text-muted">{{receivable.vehicle}}</span> will be added back into inventory with these details:</h4>
                                <div class="form-row form-group">
                                    <div class="col-form-label col-3 col-xs-12">
                                        <label for="vinCertify">VIN</label>
                                    </div>
                                    <div class="col">
                                        @if (receivable) {
                                            <input type="text" readonly class="form-control-plaintext text-muted" id="vin" value="{{receivable.vin}}" />
                                        }
                                    </div>
                                    <div class="col">
                                        <select class="form-control form-control-sm" id="vinCertify" formControlName="vinCertify">
                                            @for (level of certifyLevels; track level.code) {
                                                <option value="{{level.code.toLowerCase()}}">{{level.description}}</option>
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div class="form-row form-group">
                                    <div class="col-form-label col col-xs-12">
                                        <label for="stockNumber">Stock Number</label>
                                    </div>
                                    <div class="col">
                                        <div class="input-group input-group-sm">
                                            <input type="text" class="form-control form-control-sm" id="stockNumber" formControlName="stockNumber" />
                                            <div class="input-group-append">
                                                <span class="input-group-text">{{receivable.stock}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-form-label col col-xs-12">
                                        <label for="acv_{{key || ''}}"><abbr title="Actual Cash Value">ACV</abbr></label>
                                    </div>
                                    <div class="col">
                                        <currency-input id="acv_{{key || ''}}" [control]="form.get('acv')"></currency-input>
                                    </div>
                                </div>
                                <div class="form-row form-group">
                                    <div class="col-form-label col col-xs-12">
                                        <label for="price_{{key || ''}}">Sellling Price</label>
                                    </div>
                                    <div class="col">
                                        <currency-input id="price_{{key || ''}}" [control]="form.get('price')"></currency-input>
                                    </div>
                                    <div class="col-form-label col col-xs-12">
                                        <label for="down_{{key || ''}}">Down Payment</label>
                                    </div>
                                    <div class="col">
                                        <currency-input id="down_{{key || ''}}" [control]="form.get('down')"></currency-input>
                                    </div>
                                </div>
                                <div class="form-row form-group">
                                    <div class="col-form-label col-3 col-xs-12">
                                        <label for="mileage_{{key || ''}}">Mileage</label>
                                    </div>
                                    <div class="col">
                                        <div class="input-group input-group-sm">
                                            <count-input id="mileage_{{key || ''}}" [control]="form.get('mileage')"></count-input>
                                            <div class="input-group-append">
                                                <span class="input-group-text">{{mileage}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <select class="form-control form-control-sm" id="odometerStatus" formControlName="odometerStatus">
                                            @for (status of odometerStatuses; track status.value) {
                                                <option value="{{status.value.toLowerCase()}}">{{status.name}}</option>
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div class="form-row form-group">
                                    <div class="col-form-label col col-xs-12">
                                        <label for="titleStatus">Title Condition</label>
                                    </div>
                                    <div class="col">
                                        <select class="form-control form-control-sm" id="titleStatus" formControlName="titleStatus">
                                            @for (condition of titleConditions; track condition.value) {
                                                <option value="{{condition.value.toLowerCase()}}">{{condition.name}}</option>
                                            }
                                        </select>
                                    </div>
                                    <div class="col-form-label col col-xs-12">
                                        <label for="airbagStatus">Airbag Status</label>
                                    </div>
                                    <div class="col">
                                        <select class="form-control form-control-sm" id="airbagStatus" formControlName="airbagStatus">
                                            @for (status of airbagStatuses; track status.value) {
                                                <option value="{{status.value.toLowerCase()}}">{{status.name}}</option>
                                            }
                                        </select>
                                    </div>
                                </div>
                                <hr />
                                <div class="form-row form-group">
                                    <div class="col-form-label col-3 col-xs-12">
                                        <label for="announcement">Repo Announcement</label>
                                    </div>
                                    <div class="col-xs-12 col-9">
                                        <input type="text" class="form-control form-control-sm" id="announcement" formControlName="announcement" />
                                    </div>
                                </div>
                                <div class="form-row form-group">
                                    <div class="col-form-label col col-xs-12">
                                        <label for="location">Repo Location</label>
                                    </div>
                                    <div class="col">
                                        <select class="form-control form-control-sm" id="location" formControlName="location">
                                            @for (lot of lots; track lot.id) {
                                                <option value="{{lot.id}}">{{lot.contact.name}}</option>
                                            }
                                        </select>
                                    </div>
                                    <ng-container formArrayName="charges">
                                        @for (chargeForm of charges.controls; track chargeForm; let i = $index) {
                                            <div class="col-form-label col col-xs-12">
                                                <label for="amount_{{i}}">Repo Charge</label>
                                            </div>
                                            <div class="col">
                                                <currency-input [control]="charges.controls[i].get('amount')" id="amount_{{i}}"></currency-input>
                                            </div>
                                        }
                                    </ng-container>
                                </div>
                                <div class="form-row form-group">
                                    <div class="col form-check">
                                        <input type="checkbox" class="form-check-input" id="buyersGuideDisclosure" formControlName="buyersGuideDisclosure" />
                                        <label class="form-check-label" for="buyersGuideDisclosure">Repo Buyer&apos;s Guide Disclosure</label>
                                    </div>
                                    <div class="col form-check">
                                        <input type="checkbox" class="form-check-input" id="forgiven" formControlName="forgiven" />
                                        <label class="form-check-label" for="forgiven">Payoff Forgiven?</label>
                                    </div>
                                </div>
                                <div class="form-row form-group">
                                    <div class="col form-check">
                                        <input type="checkbox" class="form-check-input" id="surrendered" formControlName="surrendered" />
                                        <label class="form-check-label" for="surrendered">Voluntarily Surrendered?</label>
                                    </div>
                                    @if (receivable && (receivable.gpsCount > 0)) {
                                        <div class="col form-check">
                                            <input type="checkbox" class="form-check-input" id="gpsDevicesRetained" formControlName="gpsDevicesRetained" />
                                            <label class="form-check-label" for="gpsDevicesRetained">GPS Devices Retained?</label>
                                        </div>
                                    }
                                </div>
                            </form>
                            <div class="button-panel">
                                <button type="button" class="btn btn-sm btn-primary" [disabled]="form.invalid" (click)="repo($event)">
                                    Repossess
                                    @if (receivable) {
                                        {{receivable.vehicle}}
                                    }
                                </button>
                            </div>
                        </div>
                    }

                    <div class="tab-pane" id="repo-letters">
                        <h4 class="alert alert-danger text-center">Strict Foreclosure Procedure</h4>
                        <form [formGroup]="letterForm">
                            <div class="form-row form-group">
                                <div class="col-form-label col-2 offset-md-6">
                                    <label for="dated">Letter Date</label>
                                </div>
                                <div class="col">
                                    <input type="date" class="form-control form-control-sm" id="dated" formControlName="dated" />
                                </div>
                            </div>
                        </form>

                        <hr />
                        
                        <div class="row">
                            <div class="col-5 col-xs-12 report-options">
                                <ul class="list-group">
                                    <li class="list-group-item">
                                        <span>1</span>
                                        <p (click)="getLetter('vol-repo-letter')">Voluntary Return Letter</p>
                                    </li>
                                    <li class="list-group-item">
                                        <span>2</span>
                                        <p (click)="getLetter('after-invol-repo')">After Involuntary Repo Letter</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="col">
                                <form [formGroup]="letterForm">
                                    <div class="form-row form-group">
                                        <div class="col-form-label col col-xs-12">
                                            <label for="principal_{{key || ''}}">Principal Paid</label>
                                        </div>
                                        <div class="col">
                                            <currency-input id="principal_{{key || ''}}" [control]="letterForm.get('principal')"></currency-input>
                                        </div>
                                        <div class="col-form-label col col-xs-12">
                                            <label for="ridingCash_{{key || ''}}">Riding Cash</label>
                                        </div>
                                        <div class="col">
                                            <currency-input id="ridingCash_{{key || ''}}" [control]="letterForm.get('ridingCash')"></currency-input>
                                        </div>
                                    </div>
                                    <div class="form-row form-group">
                                        <div class="col-form-label col col-xs-12">
                                            <label for="salePrice_{{key || ''}}">Sale Price</label>
                                        </div>
                                        <div class="col">
                                            <currency-input id="salePrice_{{key || ''}}" [control]="letterForm.get('salePrice')"></currency-input>
                                        </div>
                                        <div class="col-form-label col col-xs-12">
                                            <label for="balance_{{key || ''}}">Repo Balance</label>
                                        </div>
                                        <div class="col">
                                            <currency-input id="balance_{{key || ''}}" [control]="letterForm.get('balance')"></currency-input>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <hr />

                        <form [formGroup]="letterForm">
                            <div class="form-row form-group">
                                <div class="col-form-label col col-xs-12">
                                    <label for="percentPrincipalPaid">Percent Principal Paid (Principal Paid / Sale Price)</label>
                                </div>
                                <div class="col">
                                    <percent-input id="percentPrincipalPaid_{{key || ''}}" [control]="letterForm.get('percentPrincipalPaid')"></percent-input>
                                </div>
                                <div class="col-form-label col col-xs-12">
                                    <label for="percentPrincipalPaid" class="text-danger">(Principal Paid &gt; 60%)</label>
                                </div>
                            </div>
                        </form>

                        <div class="row">
                            <div class="col-5 col-xs-12 report-options">
                                <ul class="list-group">
                                    <li class="list-group-item">
                                        <span>3</span>
                                        <p (click)="getLetter('repo-check-per-prop')">Proposal for Accepatance of Collateral in Full Satisfaction of Debt (If Percent Principal Paid &lt; 60%)</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="col">
                                <form [formGroup]="letterForm">
                                    <div class="form-row form-group">
                                        <div class="col-form-label col col-xs-12">
                                            <label for="daysUntilAvailable_{{key || ''}}">Number of days repossessed vehicle will be held</label>
                                        </div>
                                        <div class="col-3">
                                            <count-input id="daysUntilAvailable_{{key || ''}}" [control]="letterForm.get('daysUntilAvailable')"></count-input>
                                        </div>
                                        <div class="col-form-label col-1">
                                            <label for="daysUntilAvailable_{{key || ''}}">Days</label>
                                        </div>
                                    </div>
                                    <div class="form-row form-group">
                                        <div class="col form-check">
                                            <input type="checkbox" class="form-check-input" id="personalPropertyFound" formControlName="personalPropertyFound" />
                                            <label class="form-check-label" for="personalPropertyFound">
                                                Personal Property Found
                                                @if (propertyFound) {
                                                    <span>, will be held for</span>
                                                }
                                            </label>
                                        </div>
                                        @if (propertyFound) {
                                            <div class="col-3">
                                                <count-input id="daysUntilPropertyAvailable_{{key || ''}}" [control]="letterForm.get('daysUntilPropertyAvailable')"></count-input>
                                            </div>
                                            <div class="col-form-label col-1">
                                                <label for="daysUntilPropertyAvailable_{{key || ''}}">Days</label>
                                            </div>
                                        }
                                    </div>
                                </form>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col report-options">
                                <ul class="list-group">
                                    <li class="list-group-item">
                                        <span>4</span>
                                        <p (click)="getLetter('vol-return-letter')">Debtor or Obligor&apos;s Waiver of Compulsory Disposition of Consumer Goods Collateral (If Percent Principal Paid &gt; or = 60%)</p>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-5 col-xs-12 report-options">
                                <ul class="list-group">
                                    <li class="list-group-item">
                                        <span>5</span>
                                        <p (click)="getLetter('repo-private-sale')">Plan to Sell Notice &ndash; PRIVATE SALE (If Percent Principal Paid &gt; or = 60%)</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="col">
                                <form [formGroup]="letterForm">
                                    <div class="form-row form-group">
                                        <div class="col-form-label col col-xs-12">
                                            <label for="privateSellDays_{{key || ''}}">Number of days to sell date from letter date</label>
                                        </div>
                                        <div class="col-3">
                                            <count-input id="privateSellDays_{{key || ''}}" [control]="letterForm.get('privateSellDays')"></count-input>
                                        </div>
                                    </div>
                                    <div class="form-row form-group">
                                        <div class="col-form-label col col-xs-12">
                                            <label for="obligation_{{key || ''}}">Customer&apos;s Obligation to Balance Owed</label>
                                        </div>
                                        <div class="col-3">
                                           <input type="text" class="form-control form-control-sm" id="obligation" formControlName="obligation" />
                                        </div>
                                        <div class="col-form-label col-1">
                                            <label for="obligation_{{key || ''}}">Owe</label>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-5 col-xs-12 report-options">
                                <ul class="list-group">
                                    <li class="list-group-item">
                                        <span>6</span>
                                        <p (click)="getLetter('repo-public-sale')">Plan to Sell Notice &ndash; PUBLIC SALE (If Percent Principal Paid &gt; or = 60%)</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="col">
                                <form [formGroup]="letterForm">
                                    <div class="form-row form-group">
                                        <div class="col-form-label col col-xs-12">
                                            <label for="publicSaleDate">Public Sale Date</label>
                                        </div>
                                        <div class="col">
                                            <input type="date" class="form-control form-control-sm" id="publicSaleDate" formControlName="publicSaleDate" />
                                        </div>
                                        <div class="col-form-label col col-xs-12">
                                            <label for="publicSaleTime">Public Sale Time</label>
                                        </div>
                                        <div class="col">
                                            <input type="time" class="form-control form-control-sm" id="publicSaleTime" formControlName="publicSaleTime" />
                                        </div>
                                    </div>
                                    <div class="form-row form-group">
                                        <div class="col-form-label col-3 col-xs-12">
                                            <label for="publicSaleLocation">Public Sale Location</label>
                                        </div>
                                        <div class="col">
                                            <input type="text" class="form-control form-control-sm" id="publicSaleLocation" formControlName="publicSaleLocation" />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <hr />

                        <h5 class="alert alert-warning text-center">All mailed repo letters must be <strong>certified mail</strong> with return receipts requested!</h5>
                        <div class="alert alert-secondary">
                            <h5>Disclaimer</h5>
                            <p class="text-justified">
                                These letters are provided only as a service to our customers. It is the responsibility of the 
                                dealer to check on the legality of each repo letter. We recommend Mike Dunagan&apos;s book on
                                repos to make sure you are in full compliance with Texas law on repos. To obtain a copy of the 
                                book contact the <abbr title="Texas Independent Automobile Dealers Association">TIADA</abbr> 
                                at <a href="tel:15122446060">+1 (512) 244-6060</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-link" data-dismiss="modal" (click)="closed($event)"><span class="text-primary">close</span></button>
            </div>
        </div>
    </div>
</div>

<button id="btn-view-pdf-modal" data-target="#pdfViewModal" data-toggle="modal" class="btn btn-sm d-none"></button>
<div id="pdfViewModal" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog"
    aria-labelledby="pdfViewModal">
    <div class="modal-dialog modal-full-width modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Forms</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span>&times;</span>
                </button>
            </div>
            <div class="modal-body p-1">
                @if (pdf) {
                <object type="application/pdf" [data]="pdf" width="100%" height="90%"></object>
                }
                @else {
                <div class="waiting">
                    <div class="spinner-grow text-primary" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
                }
            </div>
        </div>
    </div>
</div>